import { BrowserRouter, Routes, Route, Navigate } from 'react-router-dom';
import MileageDashboard from './mileage/Dashboard';
import TripCreate from './mileage/TripCreate';
import TripList from './mileage/TripList';
import MonthlyMileage from './mileage/MonthlyMileage';
import Receipts from './mileage/Receipts';
import MileageSettings from './mileage/MileageSettings';
import MileageLayout from '../components/MileageLayout';

// Wrapper component to integrate mileage tracker into C30 dashboard
const MileageTracker = ({ user }) => {
  return (
    <div className="mileage-tracker-app">
      <Routes>
        <Route path="/" element={<MileageLayout />}>
          <Route index element={<MileageDashboard />} />
          <Route path="create-trip" element={<TripCreate />} />
          <Route path="trips" element={<TripList />} />
          <Route path="monthly" element={<MonthlyMileage />} />
          <Route path="receipts" element={<Receipts />} />
          <Route path="settings" element={<MileageSettings />} />
        </Route>
      </Routes>
    </div>
  );
};

export default MileageTracker;
